"use client";

import { useEffect } from "react";
import { useLocale } from "next-intl";

/**
 * Client component that updates the HTML lang attribute when locale changes
 */
export function HtmlLangUpdater() {
  const locale = useLocale();

  useEffect(() => {
    // Update the html lang attribute when locale changes
    document.documentElement.lang = locale;
  }, [locale]);

  return null;
}
